import Vue from "vue";

/**
 * Class BV Service
 */
export default class BVService extends Vue {
  private customActions = {
    bvCheckOffer: {method: 'POST', url: 'integration/bv/validate-credit-offer/{leadId}'},
    bvProposition: {method: 'POST', url: 'integration/bv/proposition/{leadId}'},
  };

  private resource: any = this.$resource('integration/', {}, this.customActions);

  public async bvCheckOffer(leadId: string, bvParams: any) { 
    return await this.resource.bvCheckOffer({leadId}, {bvParams});
  }

  public async bvProposition(leadId: any, bvParams: any) { 
    return await this.resource.bvProposition({leadId}, {bvParams});
  }
}
